var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoStories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1818 4.83301L22.9091 12.394V29.0281L30.1818 22.2233V4.83301ZM4 12.394V34.5476C4 34.9257 4.36364 35.3037 4.72727 35.3037C4.87273 35.3037 4.94545 35.2281 5.09091 35.2281C7.05455 34.2452 9.89091 33.5647 12 33.5647C14.8364 33.5647 17.8909 34.1696 20 35.833V12.394C17.8909 10.7306 14.8364 10.1257 12 10.1257C9.16364 10.1257 6.10909 10.7306 4 12.394ZM36 32.8086V12.394C35.1273 11.7135 34.1818 11.2598 33.0909 10.8818V31.2964C31.4909 30.7672 29.7455 30.5403 28 30.5403C25.5273 30.5403 21.9636 31.5233 20 32.8086V35.833C21.9636 34.5476 25.5273 33.5647 28 33.5647C30.4 33.5647 32.8727 34.0184 34.9091 35.1525C35.0545 35.2281 35.1273 35.2281 35.2727 35.2281C35.6364 35.2281 36 34.8501 36 34.472V32.8086Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoStories);
export default __webpack_public_path__ + "static/media/auto_stories.53055472f7f9c5389b1afbfd57c83041.svg";
export { ForwardRef as ReactComponent };